<h1 mat-dialog-title class="editHeader text-center blueHeader dialogHeader text-white">{{headerTitle}}</h1>
<mat-dialog-content class="mb-4">
  <div class="mt-3 wid">
    <div class="col-md-12 mb-1">
      <label class="payingClinic col-md-6">Plan</label>
      <div class="col-md-6 d-inline-block">
        <input type="radio" id="plan1" name="plan" [(ngModel)]="plan" value="5ece9d05bac44142faa1cbef">
        <label for="plan1" class="ml-1">Professional</label>
        <input type="radio" class="ml-3" id="plan2" name="plan" [(ngModel)]="plan" value="5ece9ceabac44142faa1cbeb">
        <label for="plan2" class="ml-1">Basic</label>
      </div>
    </div>
    <div class="col-md-12 mb-1">
      <label for="payRefNo" class="payingClinic col-md-6">Payment Reference No.</label>
      <input type="text" class="form-control input-font name inputBox col-md-6" id="payRefNo" [(ngModel)]="payRefNo">
    </div>
    <div class="col-md-12 mb-1">
      <label for="paymentDate" class="payingClinic col-md-6">Payment Date</label>
      <div class="col-md-6 d-inline-block text-center payDate">
        <my-date-picker name="paymentDate" [options]="myDatePickerOptions" [(ngModel)]="paymentDate"
          (dateChanged)="onPaymentDateChanged($event)" placeholder="Payment Date">
        </my-date-picker>
      </div>
    </div>

    <div class="col-md-12 mb-1">
      <label for="paidAmount" class="payingClinic col-md-6">Paid Amount</label>
      <input type="number" class="form-control input-font name inputBox col-md-6" id="paidAmount"
        [(ngModel)]="paidAmount">
    </div>
    <!-- <div class="col-md-12 mb-1">
      <label for="maxDoctors" class="payingClinic col-md-6">Max Doctors</label>
      <input type="number" class="form-control input-font name inputBox col-md-6" id="maxDoctors"
        [(ngModel)]="maxDoctors">
    </div> -->
    <div class="col-md-12 mb-1">
      <label for="status_change" class="payingClinic col-md-6">Status Change</label>
      <select name="status_change" class="form-control input-font name inputBox col-md-6" [(ngModel)]="status_change">
        <option value="AUTO">AUTO</option>
        <option value="MANUAL">MANUAL</option>
      </select>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row col-md-12 justify-content-md-center ml-3">
    <button mat-button class="mat-raised-button mr-4 btnWidth btn blankTurquoise"
      (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button class="mat-raised-button  btn turquoiseBtn btnWidth btn-sm updateButton"
      (click)="updateItem()">Update</button>

  </div>
</mat-dialog-actions>
